import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgJibit = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='url(#jibit_svg__a)'
      d='M0 5.717A5.72 5.72 0 0 1 5.719-.002H18.28A5.72 5.72 0 0 1 24 5.717v12.562a5.72 5.72 0 0 1-5.719 5.719H5.719A5.72 5.72 0 0 1 0 18.279z'
    />
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M4.853 4.58a.94.94 0 0 1 1.024.203l6.81 6.81a.94.94 0 0 1-1.329 1.33L6.152 7.715v5.035a5.84 5.84 0 0 0 2.746 4.959.94.94 0 1 1-.999 1.592 7.72 7.72 0 0 1-3.626-6.551V5.448a.94.94 0 0 1 .58-.868m13.934-.072c.52 0 .94.42.94.94v7.303A7.73 7.73 0 0 1 12 20.479a.94.94 0 0 1 0-1.88 5.85 5.85 0 0 0 5.848-5.848V5.448c0-.52.42-.94.94-.94'
      clipRule='evenodd'
    />
    <defs>
      <linearGradient
        id='jibit_svg__a'
        x1={22.324}
        x2={1.669}
        y1={22.322}
        y2={1.666}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#433DD7' />
        <stop offset={1} stopColor='#226CE9' />
      </linearGradient>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgJibit)
export default ForwardRef
